import React, { useRef, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { InputContainer, StyledTextarea } from '../../styles/StyledComponents';

const ChatInput = ({ value, onChange, onSubmit, disabled }) => {
  const textareaRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <InputContainer>
      <Box sx={{ 
        maxWidth: '800px', 
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        gap: 1
      }}>
        <StyledTextarea
          ref={textareaRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type a message..."
          disabled={disabled}
          rows={1}
        />
        <IconButton
          onClick={onSubmit}
          disabled={disabled || !value.trim()}
          sx={{
            alignSelf: 'flex-end',
            mb: '6px',
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'action.hover'
            }
          }}
        >
          <SendIcon />
        </IconButton>
      </Box>
    </InputContainer>
  );
};

export default ChatInput;
